import { ref } from 'vue'

import api from '@/store/api'

// Shared across callers so the Orders page and the AI Agents page fetch once.
const status = ref(null)
const loading = ref(false)
let inflight = null

// Mirrors AppSidebar: catering merchants get cateringSections (no AI Agents),
// and the 'ai' nav section is filtered out without the 'ai' capability.
export const showsAiAgentsNav = store =>
  !store.getters.isCatering && !!store.state.loggedInUser?.attributes?.capabilities?.includes('ai')

const load = () => {
  if (status.value) return Promise.resolve(status.value)
  if (inflight) return inflight
  loading.value = true
  inflight = api
    .call('GET', 'agents/setup_status', {}, { receive: false, save: false })
    .then(response => {
      status.value = response?.data?.data ?? null
      return status.value
    })
    .finally(() => {
      loading.value = false
      inflight = null
    })
  return inflight
}

const dismiss = async () => {
  const dismissedAt = new Date().toISOString()
  await api.call('PUT', 'profile', { profile: { agent_wizard_dismissed_at: dismissedAt } })
  status.value = { ...(status.value ?? {}), dismissed_at: dismissedAt }
}

export const resetAgentSetupStatus = () => {
  status.value = null
  loading.value = false
  inflight = null
}

export function useAgentSetupStatus() {
  return { status, loading, load, dismiss }
}
